import type { Currency } from '@repo-level/core-front';
import type { Lootbox } from 'api/common';
import { BonusAttributeField, LootboxStage } from 'api/common';
import {
  groupMemberDIAMOND,
  groupMemberGOLD,
  groupMemberPLATINUM,
} from 'helpers/user';
import { getCurrencyCentsAndCode } from 'helpers/wallet';
import moment from 'moment';
import type { TFunction } from 'react-i18next';

export const getMockLootBox = (t: TFunction<'wheel'>): Lootbox => ({
  id: 15,
  title: 'Lootbox TEST',
  stage: LootboxStage.Activated,
  strategy: 'lootbox_item',
  createdAt: '2023-07-20T12:56:22.076Z',
  validUntil: '2023-08-03T12:56:21.846Z',
  display: 1,
  items: [
    {
      weight: 23,
      prize: false,
      createdAt: '2023-07-20T12:56:22.081Z',
      bonuses: [
        {
          title: t('FS', { amount: 10 }),
          type: 'freespins',
          attributes: [
            {
              field: BonusAttributeField.FreespinsCount,
              value: 10,
            },
            {
              field: BonusAttributeField.FreespinsMaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
          resultBonus: [
            {
              field: BonusAttributeField.Wager,
              value: 35,
            },
            {
              field: BonusAttributeField.MaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
        },
      ],
      id: 127,
    },
    {
      weight: 17,
      prize: false,
      createdAt: '2023-07-20T12:56:22.086Z',
      bonuses: [
        {
          title: t('FS', { amount: 15 }),
          type: 'freespins',
          attributes: [
            {
              field: BonusAttributeField.FreespinsCount,
              value: 15,
            },
            {
              field: BonusAttributeField.FreespinsMaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
          resultBonus: [
            {
              field: BonusAttributeField.Wager,
              value: 35,
            },
            {
              field: BonusAttributeField.MaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
        },
      ],
      id: 128,
    },
    {
      weight: 13,
      prize: false,
      createdAt: '2023-07-20T12:56:22.090Z',
      bonuses: [
        {
          title: t('FS', { amount: 25 }),
          type: 'freespins',
          attributes: [
            {
              field: BonusAttributeField.FreespinsCount,
              value: 25,
            },
            {
              field: BonusAttributeField.FreespinsMaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
          resultBonus: [
            {
              field: BonusAttributeField.Wager,
              value: 35,
            },
            {
              field: BonusAttributeField.MaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
        },
      ],
      id: 129,
    },
    {
      weight: 8,
      prize: false,
      createdAt: '2023-07-20T12:56:22.094Z',
      bonuses: [
        {
          title: t('FS', { amount: 50 }),
          type: 'freespins',
          attributes: [
            {
              field: BonusAttributeField.FreespinsCount,
              value: 50,
            },
            {
              field: BonusAttributeField.FreespinsMaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
          resultBonus: [
            {
              field: BonusAttributeField.Wager,
              value: 35,
            },
            {
              field: BonusAttributeField.MaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
        },
      ],
      id: 130,
    },
    {
      weight: 2,
      prize: false,
      createdAt: '2023-07-20T12:56:22.098Z',
      bonuses: [
        {
          title: t('FS', { amount: 100 }),
          type: 'freespins',
          attributes: [
            {
              field: BonusAttributeField.FreespinsCount,
              value: 100,
            },
            {
              field: BonusAttributeField.FreespinsMaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
          resultBonus: [
            {
              field: BonusAttributeField.Wager,
              value: 35,
            },
            {
              field: BonusAttributeField.MaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
        },
      ],
      id: 131,
    },
    {
      weight: 20,
      prize: false,
      createdAt: '2023-07-20T12:56:22.102Z',
      bonuses: [
        {
          title: t('FS', { amount: 35 }),
          type: 'bonus',
          attributes: [
            {
              field: BonusAttributeField.BonusAmount,
              value: [
                {
                  currency: 'EUR',
                  amountCents: 500,
                },
                {
                  currency: 'USD',
                  amountCents: 500,
                },
                {
                  currency: 'CAD',
                  amountCents: 500,
                },
                {
                  currency: 'AUD',
                  amountCents: 500,
                },
                {
                  currency: 'NZD',
                  amountCents: 500,
                },
                {
                  currency: 'NOK',
                  amountCents: 5000,
                },
                {
                  currency: 'BTC',
                  amountCents: 20_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 5_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 3_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 6_500_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 8_000_000_000,
                },
              ],
            },
            {
              field: BonusAttributeField.Wager,
              value: 35,
            },
            {
              field: BonusAttributeField.MaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
        },
      ],
      id: 132,
    },
    {
      weight: 11,
      prize: false,
      createdAt: '2023-07-20T12:56:22.104Z',
      bonuses: [
        {
          title: t('FS', { amount: 75 }),
          type: 'bonus',
          attributes: [
            {
              field: BonusAttributeField.BonusAmount,
              value: [
                {
                  currency: 'EUR',
                  amountCents: 1000,
                },
                {
                  currency: 'USD',
                  amountCents: 1000,
                },
                {
                  currency: 'CAD',
                  amountCents: 1000,
                },
                {
                  currency: 'AUD',
                  amountCents: 1000,
                },
                {
                  currency: 'NZD',
                  amountCents: 1000,
                },
                {
                  currency: 'NOK',
                  amountCents: 10_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 40_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 10_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 6_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 15_000_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 15_000_000_000,
                },
              ],
            },
            {
              field: BonusAttributeField.Wager,
              value: 35,
            },
            {
              field: BonusAttributeField.MaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
        },
      ],
      id: 133,
    },
    {
      weight: 5,
      prize: false,
      createdAt: '2023-07-20T12:56:22.107Z',
      bonuses: [
        {
          title: t('FS', { amount: 100 }),
          type: 'bonus',
          attributes: [
            {
              field: BonusAttributeField.BonusAmount,
              value: [
                {
                  currency: 'EUR',
                  amountCents: 5000,
                },
                {
                  currency: 'USD',
                  amountCents: 5000,
                },
                {
                  currency: 'CAD',
                  amountCents: 5000,
                },
                {
                  currency: 'AUD',
                  amountCents: 5000,
                },
                {
                  currency: 'NZD',
                  amountCents: 5000,
                },
                {
                  currency: 'NOK',
                  amountCents: 50_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 200_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 50_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 30_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 65_000_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 80_000_000_000,
                },
              ],
            },
            {
              field: BonusAttributeField.Wager,
              value: 35,
            },
            {
              field: BonusAttributeField.MaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
        },
      ],
      id: 134,
    },
    {
      weight: 1,
      prize: false,
      createdAt: '2023-07-20T12:56:22.109Z',
      bonuses: [
        {
          title: t('FS', { amount: 200 }),
          type: 'bonus',
          attributes: [
            {
              field: BonusAttributeField.BonusAmount,
              value: [
                {
                  currency: 'EUR',
                  amountCents: 10_000,
                },
                {
                  currency: 'USD',
                  amountCents: 10_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 10_000,
                },
                {
                  currency: 'AUD',
                  amountCents: 10_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 10_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 100_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 400_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 100_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 60_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 125_000_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 150_000_000_000,
                },
              ],
            },
            {
              field: BonusAttributeField.Wager,
              value: 35,
            },
            {
              field: BonusAttributeField.MaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
        },
      ],
      id: 135,
    },
  ],
  groupKey: 'manual_lootbox_bonus1',
});

export const getMockLootBoxVIP = (t: TFunction<'wheel'>): Lootbox => ({
  id: 15,
  title: 'Lootbox TEST',
  stage: LootboxStage.Activated,
  strategy: 'lootbox_item',
  createdAt: '2023-07-20T12:56:22.076Z',
  validUntil: '2023-08-03T12:56:21.846Z',
  display: 1,
  items: [
    {
      weight: 23,
      prize: false,
      createdAt: '2023-07-20T12:56:22.081Z',
      bonuses: [
        {
          title: t('FS', { amount: 10 }),
          type: 'freespins',
          attributes: [
            {
              field: BonusAttributeField.FreespinsCount,
              value: 10,
            },
            {
              field: BonusAttributeField.FreespinsMaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
          resultBonus: [
            {
              field: BonusAttributeField.Wager,
              value: 35,
            },
            {
              field: BonusAttributeField.MaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
        },
      ],
      id: 127,
    },
    {
      weight: 17,
      prize: false,
      createdAt: '2023-07-20T12:56:22.086Z',
      bonuses: [
        {
          title: '25% match',
          type: 'freespins',
          attributes: [
            {
              field: BonusAttributeField.FreespinsCount,
              value: 15,
            },
            {
              field: BonusAttributeField.FreespinsMaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
          resultBonus: [
            {
              field: BonusAttributeField.Wager,
              value: 35,
            },
            {
              field: BonusAttributeField.MaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
        },
      ],
      id: 128,
    },
    {
      weight: 13,
      prize: false,
      createdAt: '2023-07-20T12:56:22.090Z',
      bonuses: [
        {
          title: t('FS', { amount: 25 }),
          type: 'freespins',
          attributes: [
            {
              field: BonusAttributeField.FreespinsCount,
              value: 25,
            },
            {
              field: BonusAttributeField.FreespinsMaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
          resultBonus: [
            {
              field: BonusAttributeField.Wager,
              value: 35,
            },
            {
              field: BonusAttributeField.MaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
        },
      ],
      id: 129,
    },
    {
      weight: 8,
      prize: false,
      createdAt: '2023-07-20T12:56:22.094Z',
      bonuses: [
        {
          title: '50% match',
          type: 'freespins',
          attributes: [
            {
              field: BonusAttributeField.FreespinsCount,
              value: 50,
            },
            {
              field: BonusAttributeField.FreespinsMaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
          resultBonus: [
            {
              field: BonusAttributeField.Wager,
              value: 35,
            },
            {
              field: BonusAttributeField.MaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
        },
      ],
      id: 130,
    },
    {
      weight: 2,
      prize: false,
      createdAt: '2023-07-20T12:56:22.098Z',
      bonuses: [
        {
          title: t('FS', { amount: 50 }),
          type: 'freespins',
          attributes: [
            {
              field: BonusAttributeField.FreespinsCount,
              value: 50,
            },
            {
              field: BonusAttributeField.FreespinsMaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
          resultBonus: [
            {
              field: BonusAttributeField.Wager,
              value: 35,
            },
            {
              field: BonusAttributeField.MaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
        },
      ],
      id: 131,
    },
    {
      weight: 20,
      prize: false,
      createdAt: '2023-07-20T12:56:22.102Z',
      bonuses: [
        {
          title: '100% match',
          type: 'bonus',
          attributes: [
            {
              field: BonusAttributeField.BonusAmount,
              value: [
                {
                  currency: 'EUR',
                  amountCents: 500,
                },
                {
                  currency: 'USD',
                  amountCents: 500,
                },
                {
                  currency: 'CAD',
                  amountCents: 500,
                },
                {
                  currency: 'AUD',
                  amountCents: 500,
                },
                {
                  currency: 'NZD',
                  amountCents: 500,
                },
                {
                  currency: 'NOK',
                  amountCents: 5000,
                },
                {
                  currency: 'BTC',
                  amountCents: 20_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 5_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 3_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 6_500_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 8_000_000_000,
                },
              ],
            },
            {
              field: BonusAttributeField.Wager,
              value: 35,
            },
            {
              field: BonusAttributeField.MaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
        },
      ],
      id: 132,
    },
  ],
  groupKey: 'manual_lootbox_bonus1',
});

export const SPINS_PER_DAY = 5;

export const SPINS_PER_DAY_GOLD = 7;
export const SPINS_PER_DAY_PLATINUM = 10;
export const SPINS_PER_DAY_DIAMOND = 15;

export enum WheelStatusEnum {
  Loading = 'loading',
  Spinning = 'spinning',
  Finished = 'finished',
}

export const isToday = (date: string): boolean => {
  const createdAtDate = moment.utc(date);
  const currentUtcDate = moment.utc();

  return createdAtDate.isSame(currentUtcDate, 'day');
};

export const getTimeUntilNextDay = (): number => {
  const currentUtcTime = moment.utc();
  const nextDayUtc = moment.utc().add(1, 'days').startOf('day');

  return nextDayUtc.diff(currentUtcTime) / 1000;
};

export const convertMaxWin = (
  values: { currency: string; amountCents: number }[],
  currencies: Currency[]
): string => {
  const amountsMap: { [key: string]: string[] } = {};

  const maxWinCurrencies = values.map((value) =>
    getCurrencyCentsAndCode(value.amountCents, value.currency, currencies)
  );

  maxWinCurrencies.forEach((item) => {
    if (amountsMap[item.amount]) {
      amountsMap[item.amount].push(item.currency);
    } else {
      amountsMap[item.amount] = [item.currency];
    }
  });

  return Object.entries(amountsMap)
    .map(
      ([amountCents, currencies]) => `${amountCents} ${currencies.join('/')}`
    )
    .join(', ');
};

export const getSpinsLeftAmount = (lootboxes: Lootbox[], user?: any) => {
  if (!user) return SPINS_PER_DAY;

  const spinsPerDay = (() => {
    if (groupMemberDIAMOND(user)) return SPINS_PER_DAY_DIAMOND;
    if (groupMemberPLATINUM(user)) return SPINS_PER_DAY_PLATINUM;
    if (groupMemberGOLD(user)) return SPINS_PER_DAY_GOLD;
    return SPINS_PER_DAY;
  })();

  const currentLootboxes = [...lootboxes].filter((lootbox) =>
    isToday(lootbox.createdAt)
  );
  const activatedLootboxes = [...currentLootboxes].filter(
    ({ stage, title }) =>
      stage === LootboxStage.Activated &&
      !EXTRA_SPIN_LOOTBOX_TITLES.includes(title)
  );
  return spinsPerDay - activatedLootboxes.length;
};

export const formatLootboxItemTitle = (str: string): string => {
  const regex = /\b\s*Wheel\b/gi;
  return str.replace(regex, '').trim();
};

export const EXTRA_SPIN_LOOTBOX_TITLES = [
  'Extra Lucky Spin',
  'VIP Extra Lucky Spin',
];
